import Index from './page';

function App() {
  return (
    <div className="App">
      <Index/>
    </div>
  );
}

export default App;
